<template>

    <div class="card" v-bind:class="{ job_completed_card : job.workerIntervention.isCompleted }">



        <div class="translucent"
             v-on:click="disablePropagation"
             v-if="job.workerIntervention.isTrasparentActif && !job.workerIntervention.isCompleted" ></div>
        <transition name="fademessage">
            <div class="confirmationMessage" v-if="job.workerIntervention.flashMessage">{{'Well done thanks !'|trans}}</div>
        </transition>

        <transition name="fademessage">
            <div class="confirmationMessageError" v-if="job.workerIntervention.flashErrorMessage">{{'Something was wrong please try later !'|trans}}</div>
        </transition>


        <transition name="fademessage">
            <div class="errorConnectionMessage" v-if="job.workerIntervention.showFlashErrorConnectionMessage">
                {{'Your not logged in and the data will not be saved!'|trans}}
                <br>
                <a href="/worker/" class="btn btn-sm btn-login">{{'Please click here to log in'|trans}}</a>
            </div>
        </transition>


        <div class="card-header" v-bind:class="{ job_completed : job.workerIntervention.isCompleted }" v-on:click="openCloseJob">

            <div class="col-md-9 col-sm-9 col-xs-9 no-padding">
                <div class="title">
                    <span class=" ">{{job.dateJobStart|DateFormat('H:mm')}}</span>
                    <span v-if="isJobNew && job.workerIntervention.pureContact.discloseAccepted && job.isPureContact">
                        {{job.customer.lastname|Upper}}
                    </span>
                    <span v-if="!isJobNew  || (job.isPureContact !== true && job.workerIntervention.buttons.IsWorkerInPlace)" >
                        {{job.customer.lastname|Upper}}
                    </span>
                    <span v-if="job.isWorkerTheOwner">
                        {{job.customer.lastname|Upper}}
                    </span>
                </div>

                <div class="">{{ (job.jobTypesChainTranslated.join(' > ') + '. ' + job.jobDescription) | Truncate(50) }}</div>
            </div>

            <div class="col-md-3 col-sm-3 col-xs-3 no-padding tags-info">

                <!-- <span v-if="job.isPureContact && user.workerIsNovice !== true && job.isWorkerTheOwner !== true " class="tag tag-purecontact half-width">
                    <i class="fa fa-handshake-o"></i>
                </span>-->

                <span class="job-id tag  pull-right half-width">
                    # {{job.id|TruncateJobNumber}}
                </span>


                <span  v-if="job.pricePolicy && job.pricePolicy.show_warning && user.workerIsNovice !== true && job.isWorkerTheOwner !== true " class="price-policy-btn tag-primary tag pull-right half-width"  v-on:click.stop="onPolicyCLick" >
                     <i class="fa fa-file-text"></i>
                </span>

                <span v-if="(job.worker.percentMin !== job.worker.percentMax) && !job.isPureContact && user.workerIsNovice !== true" class="percent_worker tag pull-right half-width "
                      v-bind:class="{'half-width':job.PricePolicy,'full-width':(!job.PricePolicy || !job.PricePolicy.show_warning)}"
                >
                    {{job.workerPercent|Round(2)}}%
                </span>

            </div>
        </div>

        <!--
            RUNNING LATE, on the collapsed card itself, so a worker who is stuck in
            traffic can warn the customer in one tap without opening the job.

            @click.stop is required: the card header above toggles the job open, and
            without it every tap in here would also expand the card.

            canDeclareRunningLate is false while a refund is still possible, so this
            whole block is invisible until the worker has nothing left to gain by
            provoking a cancellation.
        -->
        <div class="running-late-holder" v-if="canDeclareRunningLate" v-on:click.stop>
            <RunningLate
                    v-bind:job="job"
                    v-bind:user="user">
            </RunningLate>
        </div>


        <div  class="policyContent" v-show="is_price_policy_open && user.workerIsNovice !== true" v-bind:ref="'pricePolicy'">

            <div class="col-xs-10">
                <h4>{{'Price Policy'|trans}}</h4>
            </div>
            <div class="col-xs-2">
                <i class="fa fa-close fa-2x"  v-on:click="is_price_policy_open = !is_price_policy_open"></i>
            </div>

            <div class="col-xs-12">


                <table class="table table-striped">
                    <tbody>
                    <tr>
                        <td colspan="2">{{job.pricePolicy.title}}</td>
                        <td ></td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.hourMinimum)">
                        <td>{{'Hours Minimun'|trans}}</td>
                        <td>{{job.pricePolicy.hourMinimum}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.quarterHourMinimum)">
                        <td>{{'Quarter Hour Minimun'|trans}}</td>
                        <td>{{job.pricePolicy.quarterHourMinimum }}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.calloutPrice)">
                        <td>{{'Callout Price'|trans}}</td>
                        <td>{{job.pricePolicy.calloutPrice|Round(2)}} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.quarterhourPrice)">
                        <td>{{'Quarter Hour Price'|trans}}</td>
                        <td>{{job.pricePolicy.quarterhourPrice|Round(2)}} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.eveningPrice)">
                        <td>{{'Evening Price'|trans}}</td>
                        <td>{{job.pricePolicy.eveningPrice|Round(2) }} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.firstQuarterHourPrice)">
                        <td>{{'First Quarter Hour Price'|trans}}</td>
                        <td>{{job.pricePolicy.firstQuarterHourPrice|Round(2) }} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.firstHourPrice)">
                        <td>{{'First Hour Price'|trans}}</td>
                        <td>{{job.pricePolicy.firstHourPrice|Round(2) }} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.saturdayPrice)">
                        <td>{{'Saturday Price'|trans}}</td>
                        <td>{{job.pricePolicy.saturdayPrice|Round(2)}} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.sundayPrice)">
                        <td>{{'Sunday Price'|trans}}</td>
                        <td>{{job.pricePolicy.sundayPrice|Round(2)}} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.hourPrice)">
                        <td>{{'Hour Price'|trans}}</td>
                        <td>{{job.pricePolicy.hourPrice|Round(2)}} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr v-if="hideIfValueLessOrEqualToZero(job.pricePolicy.nightPrice)">
                        <td>{{'Night Price'|trans}}</td>
                        <td>{{job.pricePolicy.nightPrice|Round(2)}} {{ $currency.symbol(job.customerAddressIntervention.countryName)}}}</td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <div v-if="conditionLanguageSelected === item.lang " v-for="(item) in job.pricePolicy.pricePoliciesTranslations" class="scrollable">{{ item.conditions }}</div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="2 " class="no-padding">
                            <button class="btn btn-primary full-width "  v-on:click="is_price_policy_open = !is_price_policy_open;" >
                                {{'Close Price Policy'|trans}}
                            </button>
                        </td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>


        <transition name="openjob" mode="out-in">
        <div v-bind:class="'card-body '+job.workerIntervention.extraHeight" v-show="isOpenJob" v-bind:ref="'jobCard'">


            <div v-if="job.workerIntervention.isQuizzOpen">
                <button class="btn btn-sm full-width" v-on:click="job.workerIntervention.isQuizzOpen=false"><i class="fa fa-info-circle"></i>
                    {{'See Job information'|trans}}
                </button>
            </div>

          <div class="content-description" v-if="job.workerIntervention.isQuizzOpen===false">



              <TopTagList
                  v-bind:job="job"
                  v-bind:user="user">
              </TopTagList>

              <div class="row">
                <div class="col-md-1 col-sm-1 col-xs-1">
                  <a v-bind:href="'waze://?q='+getHouseNumber()+','+job.customerAddressIntervention.street+','+job.customerAddressIntervention.zone.zip+''"
                     class="color-white waze-btn pull-left">
                    <img v-bind:src="$absoluteAssetPath('waze.png')">
                  </a>
                </div>
                <div class="col-md-11  col-sm-11 col-xs-11">
                  <!--***************************** For Pure Contact ***************************** -->
                  <span v-if="isJobNewAndPureContactAndNotNovice === true">

                    <ConfirmInline
                        v-on:confirmation="discloseAndShowBoutons('House Number', $event)"
                        v-if="!job.workerIntervention.pureContact.discloseAccepted && editable && job.isWorkerTheOwner !== true"
                    >
                      <div slot="body">
                        {{ 'As soon as the house number is disclosed, you will not be entitled to a refund for this job. A tip: do this only if you are already in the street of the client'|trans }}
                      </div>
                      <span slot="openBouton">
                                <button class="exposeBouton btn btn-xs btn-primary">{{ 'Expose House Number'|trans }}</button>
                            </span>
                    </ConfirmInline>

                    <span
                        v-if="job.workerIntervention.pureContact.discloseAccepted || job.isWorkerTheOwner === true">{{ job.customerAddressIntervention.number }}</span>
                    {{ job.customerAddressIntervention.street }} CP-{{ job.customerAddressIntervention.zone.zip }}
                    {{ job.customerAddressIntervention.zone.country }}

                  </span>
                  <!--***************************** End For Pure Contact ***************************** -->
                  <span v-if="isJobNewAndPureContactAndNotNovice === false ">
                        <span v-if="editable === true || job.isWorkerTheOwner === true">
                            {{ job.customerAddressIntervention.number }},
                        </span>
                    <span v-else>
                            ?,
                        </span>
                    {{ job.customerAddressIntervention.street }} CP-{{ job.customerAddressIntervention.zone.zip }}
                  </span>
                  <br>
                  <span class="job-description">
                    {{ job.jobTypesChainTranslated.join(' > ') }}.
                    <span v-html="job.jobDescription"></span><br>
                  </span>

                </div>
              </div>

            <div class="panel panel-default">
              <div class="panel-body">

                  <BelfixJobMessage :worker="job.worker" v-if="job.isEasyFixJob"></BelfixJobMessage>

                  <span class="tag tag-info">{{ 'Prix du job'|trans }}
                  <span v-if="job.selectedSlotPrice !== null">
                      {{ job.selectedSlotPrice }}
                  </span>
                  <span v-else>
                      {{ job.leafJobType.normalCostBasePrice|Round }}
                  </span>
                  <strong>{{ $currency.symbol(job.customerAddressIntervention.countryName) }}</strong>
                  </span>

                <div v-if="job.extra_cost" class="alert alert-danger alert-prix-job-description">
                  {{ 'Agreed on an extra fee of'|trans }}
                  <strong>
                    {{ job.extra_cost|Round }} {{ $currency.symbol(job.customerAddressIntervention.countryName) }}
                  </strong>
                  {{ 'for'|trans }} {{ job.extraCostDescription }}<br>
                </div>


                <div class="row">
                  <div class="col-md-6 col-sm-6 col-xs-6 price-description">
                    <ul class="list-simple">
                      <li><strong>{{ 'The price includes:' |trans }}</strong></li>
                      <template v-for="jobTypeService in JSON.parse(job.leafJobType.service_translated)">
                        <li><img width="4%" v-bind:src=" 'http://belfix.be' + jobTypeService.icon.icon"> {{ jobTypeService.value }}</li>
                      </template>
                    </ul>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-6 price-description">
                    <ul class="list-simple">
                      <li><strong>{{ 'This tariff does not include:' |trans }}</strong></li>
                      <li>{{ 'Extra working hours' |trans }}</li>
                      <li>{{ 'Spare parts' |trans }}</li>
                    </ul>
                  </div>
                </div>

                <div class="row">
                  <div class="description-price-job col-md-12 col-sm-12 col-xs-12">
                    <!-- TRANSLATE TODO ADRIAN -->
                    Votre montant souhaité pour ce type de mission est de
                    {{ (job.partner_price)|Round }}{{ $currency.symbol(job.customerAddressIntervention.countryName) }},
                    le client accepte de vous payer
                    {{ job.selectedSlotPrice }}{{ $currency.symbol(job.customerAddressIntervention.countryName) }} ,
                    dèslors la différence {{
                      job.selectedSlotPrice - job.partner_price
                    }}{{ $currency.symbol(job.customerAddressIntervention.countryName) }}
                    est notre commission et a été débitée de votre crédit pure-contact.
                  </div>
                </div>

              </div>
            </div>

              <div class="row">
                    <div class="col-xs-12">
                        <button class="btn btn-default full-width" @click="isHistoryOpen = !isHistoryOpen">
                            {{ 'History of this mission'|trans }}
                        </button>
                        <history-job v-bind:user="user" v-bind:job="job" v-if="isHistoryOpen"></history-job>
                    </div>
                </div>

                <div class="call-btns row" v-if="editable === true">
                    <div class="col-xs-6">
                        <PhoneNumberButton></PhoneNumberButton>
                    </div>
                    <div class="col-xs-6">
                        <div v-if="user.workerIsNovice === true">
                            <a v-bind:href="'tel:'+job.customer.default_phone.phone_link"
                               class="noAjax btn btn-default btn-call full-width">
                                <i class="fa fa-phone"></i>
                                {{job.customer.default_phone.phone_display}}
                            </a>
                        </div>
                        <div v-else>


                            <!--***************************** For Pure Contact ***************************** -->
                            <div v-if="isJobNewAndPureContact === true">

                                <ConfirmInline
                                        v-on:confirmation="discloseAndShowBoutons('PhoneNumber', $event)"
                                        v-if="!job.workerIntervention.pureContact.discloseAccepted && job.isWorkerTheOwner !== true"
                                >
                                    <div slot="body">
                                        {{'Si vous appelez le client, vous n’aurez plus droit à un remboursement pour ce job. Un conseil : ne faites ca que si vous êtes deja dans la rue du client'|trans}}
                                    </div>
                                    <div slot="openBouton">
                                        <a class=" btn btn-default btn-call full-width">
                                            <i class="fa fa-phone"></i>
                                            {{'Call Client'|trans}}
                                        </a>
                                    </div>
                                </ConfirmInline>

                                <a  v-if="job.workerIntervention.pureContact.discloseAccepted || job.isWorkerTheOwner === true" class=" btn btn-default btn-call full-width"
                                    v-bind:href="'tel:'+job.workerIntervention.customer.default_phone['phone_link']">
                                    <i class="fa fa-phone"></i>
                                    {{ job.workerIntervention.customer.default_phone['phone_display'] }}
                                </a>

                            </div >
                            <!--***************************** End For Pure Contact ***************************** -->

                            <div v-if="isJobNewAndPureContact === false">
                                <a v-if="job.workerIntervention.customerPhoneNumber===null" class="noAjax btn btn-default btn-call full-width"
                                   v-on:click="callCustomer(job.id)">
                                    <i class="fa fa-phone"></i>
                                    {{'Call Client'|trans}}
                                </a>
                                <a v-else v-bind:href="'tel:'+job.workerIntervention.customerPhoneNumber"
                                   class="noAjax btn btn-default btn-call full-width">
                                    <i class="fa fa-phone"></i>
                                    <span v-if="callCustomerButton">
                                        {{'Call Now'|trans}}
                                </span>
                                    <span v-else>
                                        {{job.workerIntervention.customerPhoneNumber}}
                                </span>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
                <div v-else>


                     <div v-if="isJobNewAndPureContactAndNotNovice === true" >
                                <ConfirmInline
                                        v-on:confirmation="discloseAndShowBoutons('House Number', $event)"
                                        v-if="!job.workerIntervention.pureContact.discloseAccepted && !editable"
                                >
                                    <div slot="body">???
                                        {{'As soon as the house number is disclosed, you will not be entitled to a refund for this job. A tip: do this only if you are already in the street of the client'|trans}}
                                    </div>
                                    <div slot="openBouton">
                                        <button class="btn btn-primary full-width">
                                            <nl2br tag="span" :text="'Expose House Number'|trans"/>
                                        </button>
                                    </div>
                                </ConfirmInline>
                    </div>

                    <a  v-if="job.workerIntervention.pureContact.discloseAccepted" class=" btn btn-default btn-call full-width"
                        v-bind:href="'tel:'+job.workerIntervention.customer.default_phone['phone_link']">
                        <i class="fa fa-phone"></i>
                        {{ job.workerIntervention.customer.default_phone['phone_display'] }}
                    </a>

                    <JobImpossible
                            v-bind:job="job"
                            v-bind:user="user"
                            v-on:confirmed="emitGetJobsAfterDelay"
                    >
                    </JobImpossible>

                    <Swap
                            v-if="job.shouldBeSwappableWithJobId !== undefined"
                            v-bind:job="job"
                            v-on:swapped="$emit('get_jobs')">
                    </Swap>

                </div>

                <div v-if="job.devisAccepted">
                    <!--<h5>{{'Quotation Accepted'|trans }}</h5>-->
                    <a v-for="(item, key) in job.devisAccepted" target="_blank" v-bind:href="getInvoicePath(item.id)" class="btn btn-sm btn-default ">
                        {{'Devis'|trans}} #{{item.id}}
                    </a>
                </div>

            </div>

            <!--{#  ********************************************** FORM ************************************************ #}}-->

            <div class="col-xs-12" v-if="editable === false">
                <div class="alert alert-danger text-center">
                    <strong>{{'Please field the previous job'|trans}}</strong>
                </div>
            </div>

            <div class='col-xs-12 quizz' v-if="editable" v-bind:class="{
            'fixedDiv':job.workerIntervention.step==='F2'||job.workerIntervention.step==='F8',
            'startQuizz':job.workerIntervention.step==='C1'|| job.workerIntervention.step==='F9' || job.workerIntervention.step==='F15',
            'thanks_customer':job.workerIntervention.step==='thanks_customer'
            }"
            >

                <transition-group name="fade" mode="out-in">

                    <div class="col-xs-12" v-if="hideBackBouton"
                         v-bind:key="'back'"
                         v-bind:class="{ 'invisible-btn' : job.workerIntervention.step === 'thanks_customer' }">

                        <button class="btn btn-xs back-btn" v-on:keyup.66="goBack()" v-on:click="goBack();job.workerIntervention.selectedJobOption=null;"><i
                                class="fa fa-arrow-left"></i> {{'Back'|trans}}
                        </button >
                    </div>



                    <div v-if="job.workerIntervention.step==='C1'" v-bind:key="'C1'">
                        <div class="col-xs-6 padding-startquizz-buttons">

                            <span v-if="isJobNewAndPureContactAndNotNovice === true && job.isWorkerTheOwner !== true" >
                                <ConfirmInline
                                        v-on:confirmation="discloseAndShowBoutons('House Number', $event)"
                                        v-if="!job.workerIntervention.pureContact.discloseAccepted && editable"
                                >
                                    <div slot="body">
                                        {{'As soon as the house number is disclosed, you will not be entitled to a refund for this job. A tip: do this only if you are already in the street of the client'|trans}}
                                    </div>
                                    <div slot="openBouton">
                                        <button class="btn btn-xs btn-primary">
                                            <nl2br tag="span" :text="'Expose House Number'|trans"/>
                                        </button>
                                    </div>
                                </ConfirmInline>

                                <button class="btn btn-primary full-width" v-if="job.workerIntervention.pureContact.discloseAccepted"
                                        v-on:click="makeChoice('C1.1'); job.workerIntervention.buttons.IsWorkerInPlace = true">
                                    {{"I\'m present"|trans}}
                                </button>
                            </span>

                            <button class="btn btn-primary full-width"
                                    v-if="isJobNewAndPureContactAndNotNovice === false || job.isWorkerTheOwner === true"
                                    v-on:click="makeChoice('C1.1'); job.workerIntervention.buttons.IsWorkerInPlace = true">
                                {{"I\'m present"|trans}}
                            </button>

                        </div>
                        <div class="col-xs-6 padding-startquizz-buttons">
                            <button class="btn btn-primary full-width"
                                    v-on:click="makeChoice('C1.2'); job.workerIntervention.buttons.IsWorkerInPlace = false">
                                <nl2br tag="span" :text="'I was not \n there'|trans"/>
                            </button>
                        </div>

                    </div>

                    <div v-if="job.workerIntervention.step==='C2'" v-bind:key="'C2'">

                        <div class="col-xs-12 alert alert-danger" v-if="workerIsToEarly==true">
                                <nl2br tag="span" :text="'The customer is not there because you are too early!'|trans"/><br>
                                <strong>{{'Job Start at'|trans}} {{job.dateJobStart|DateFormat('H:mm')}}</strong>
                        </div>

                        <div class="col-xs-6 ">
                            <button class="btn btn-primary full-width" v-on:click="makeChoice('C2.1'); ">

                                <nl2br tag="span" :text="'The client \n is there'|trans"/>
                            </button>
                        </div>
                        <div class="col-xs-6 ">

                            <button class="btn btn-primary full-width" v-on:click="makeChoice('C2.2'); " v-if="workerIsToEarly==false">
                                <nl2br tag="span" :text="'The client \n is not there'|trans"/>
                            </button>

                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C14'" v-bind:key="'C14'">

                        <p class="alert alert-important clear-both">
                            {{"Try to do your best to reach the customer. then, to help us get a payment, take a picture of the customer's door or doorbell."|trans}}
                        </p>

                        <PhoneNumberButton></PhoneNumberButton>

                        <a v-if="job.workerIntervention.customerPhoneNumber===null" class="noAjax btn btn-default btn-call full-width"
                           v-on:click="callCustomer(job.id)">
                            <i class="fa fa-phone"></i>
                            {{'Call Client'|trans}}
                        </a>

                        <a v-else v-bind:href="'tel:'+job.workerIntervention.customerPhoneNumber"
                           class="noAjax btn btn-default btn-call ">
                            <i class="fa fa-phone"></i>
                            <span v-if="callCustomerButton">
                                    {{'Call Now'|trans}}
                            </span>
                            <span v-else>
                                    {{job.workerIntervention.customerPhoneNumber}}
                            </span>
                        </a>

                        <button class="btn btn-primary" v-on:click="makeChoice('take_door_picture')">
                            {{'Take a picture of door'|trans}}
                        </button>




                    </div>

                    <div v-if="job.workerIntervention.step==='take_door_picture'" v-bind:key="'take_door_picture'" class="form-group">
                        <div slot="body">
                            <Pictures
                                    v-bind:jobid="job.id"
                                    v-bind:tagPicture="'customer_door_picture'"
                                    v-bind:multiplePictures="false"
                                    v-on:numberOfPictures:changed="job.workerIntervention.pictures.has_picture_of_door = $event > 0"
                            >
                            </Pictures>
                        </div>
                        <button class="btn btn-primary" v-on:click="makeChoice('C14.1')" v-if="job.workerIntervention.pictures.has_picture_of_door">
                            {{'Done'|trans}}
                        </button>
                    </div>

                    <div v-if="job.workerIntervention.step==='F1'" v-bind:key="'F1'" class="form-group">
                        <div class="col-xs-12">
                            <h4 class="text-center">{{'Why ?'|trans}}</h4>

                            <NotAbleToGo
                                    v-bind:job="job"
                                    v-bind:user="user"
                                    v-on:confirmed="makeChoice('F9.3')">
                            </NotAbleToGo>

                            <CustomerNotOkOnPhone
                                    v-bind:job="job"
                                    v-bind:user="user"
                                    v-on:confirmed="makeChoice('F9.3')">
                            </CustomerNotOkOnPhone>

                            <JobImpossible
                                    v-bind:job="job"
                                    v-bind:user="user"
                                    v-on:confirmed="emitGetJobsAfterDelay">
                            </JobImpossible>

                            <button class="btn btn-primary" v-on:click="job.workerIntervention.fails.failId = 50">{{'Other raison'|trans}}
                            </button>

                            <br>

                            <OtherRaisonExplain
                                    v-bind:label="'Please write minimun 8 characters'|trans"
                                    v-bind:placeholder="'Explain the raison'|trans" v-if="job.workerIntervention.fails.failId===50"
                                    v-on:continue="makeChoice('F1.1', {failId: 50})" v-model="job.workerIntervention.raisonOfWorkerAbsence">
                            </OtherRaisonExplain>

                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C4'" v-bind:key="'C4'">
                        <div class="col-xs-6 ">
                            <button class="btn btn-primary full-width" v-on:click="makeChoice('C4.1'); ">
                                <nl2br tag="span" :text="'Sign the \n entry voucher'|trans"/>
                            </button>
                        </div>

                        <div class="col-xs-6 ">
                            <button class="btn btn-primary full-width" v-on:click="makeChoice('C4.2'); "
                                    v-model="job.workerIntervention.problem">
                                {{'Problem ?'|trans}}
                            </button>
                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='F2'" v-bind:key="'F2'">
                        <VoucherEntry v-bind:voucher="job.workerIntervention.voucher"
                                      v-bind:job="job"
                                      v-on:save="makeChoice('F2.1')"
                        >
                        </VoucherEntry>
                    </div>

                    <div v-if="job.workerIntervention.step==='F10'" v-bind:key="'F10'">
                        <CustomerInformation v-bind:customer="job.workerIntervention.customer"
                                             v-on:save="makeChoice('F10.1')"
                        >
                        </CustomerInformation>
                    </div>

                    <div v-if="job.workerIntervention.step==='thanks_customer'" v-bind:key="'thanks_customer'" class="text-center thanks-message-customer">
                            <h4>{{'THANKS'|trans}}</h4>
                            <span class="fa fa-thumbs-up fa-3x"></span><br>

                            <button
                                    v-on:click="makeChoice(job.workerIntervention.nextStepAfterThanks)"
                                    class="go_next_invisible "
                                    v-bind:style="opacityJobsQttIncrease()"
                            >
                                {{'Click here to continue'|trans}}
                            </button>
                    </div>

                    <div v-if="job.workerIntervention.step==='C5'" v-bind:key="'C5'">

                        <div class="col-xs-12" v-if="confirm_client_do_not_want_sign">
                            <div class="alert alert-important">
                                {{'Proposes a package to the client so as not to have a bad hearing at the end of the intervention'|trans}}
                                <button class="btn btn-default" v-on:click="makeChoice('C5.2');">
                                    {{'Confirm'|trans}}
                                </button>
                            </div>

                        </div>
                        <div class="col-xs-12 no-margin-bottom" v-if="confirm_client_do_not_want_sign==false">
                            <button class="btn btn-primary" v-on:click="confirm_client_do_not_want_sign=true"
                                    v-model="job.workerIntervention.problem.will_not_pay">
                                {{'The customer doesn\'t want to sign ?'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12 no-margin-bottom">
                            <button class="btn btn-primary" v-on:click="makeChoice('C5.6');"
                                    v-model="job.workerIntervention.problem.do_not_want_to_sign">
                                {{'The customer doesn\'t want to pay ?'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12 no-margin-bottom" v-if="job.first !== true">
                            <button class="btn btn-primary " v-on:click="makeChoice('C5.3');"
                                    v-model="job.workerIntervention.problem.warranty">
                                {{'Warranty (fail) ?'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12 no-margin-bottom" v-if="job.first !== true">
                            <button class="btn btn-primary " v-on:click="makeChoice('C5.4');"
                                    v-model="job.workerIntervention.problem.doublon">
                                {{'Duplicate (fail) ?'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12 no-margin-bottom">
                            <button class="btn btn-primary" v-on:click="job.workerIntervention.fails.failId = 32"
                                    v-model="job.workerIntervention.problem.other">
                                {{'Other: explain (fail). ?'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12 ">
                            <OtherRaisonExplain
                                    v-bind:label="'Please write minimun 8 characters'|trans"
                                    v-bind:placeholder="'Explain the raison'|trans"
                                    v-if="job.workerIntervention.fails.failId == 32"
                                    v-on:continue="makeChoice('C5.5')" v-model="job.workerIntervention.problem.otherExplain">
                            </OtherRaisonExplain>
                        </div>


                    </div>

                    <div v-if="job.workerIntervention.step==='take_sticker_picture'" v-bind:key="'take_sticker_picture'" class="form-group">
                        <div slot="body">
                            <Pictures
                                    v-bind:jobid="job.id"
                                    v-bind:tagPicture="'take_sticker_picture'"
                                    v-bind:multiplePictures="false"
                                    v-on:numberOfPictures:changed="job.workerIntervention.pictures.has_picture_of_sticker = $event > 0"
                            >
                            </Pictures>
                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='quotation'" v-bind:key="'quotation'" class="form-group">
                        <Quotation
                                v-bind:user="user"
                                v-bind:job="job"
                                v-bind:quote="job.workerIntervention.quote"
                                v-on:quoteDone="makeChoice('C5.7')"
                        ></Quotation>

                    </div>

                    <div v-if="job.workerIntervention.step==='C8'" v-bind:key="'C8'">

                        <div class="col-xs-12">
                            <div class="alert alert-success text-center">
                                <strong>{{'You can start to work'|trans}}</strong>
                            </div>
                        </div>

                        <div class="col-xs-12">
                            <button class="btn btn-default" v-on:click="makeChoice('quotation')">
                                {{'Create a quote'|trans}}
                            </button>

                            <button class="btn btn-default" v-on:click="makeChoice('take_sticker_picture')">
                                {{'Take a picture of sticker'|trans}}
                                <span class="fa fa-1x fa-check-circle green-a-text" v-if="job.workerIntervention.pictures.has_picture_of_sticker"></span>
                            </button>
                        </div>

                        <div class="col-xs-12 ">
                            <button class="btn btn-primary full-width" v-on:click="makeChoice('C8.1');">
                                {{'Sign the voucher'|trans}}
                            </button>
                        </div>

                    </div>

                    <div v-if="job.workerIntervention.step==='C9'" v-bind:key="'C9'">

                        <div class="col-xs-12 ">
                            <PhoneNumberButton></PhoneNumberButton>
                        </div>

                        <div class="col-xs-12 ">
                            <button class="btn btn-primary full-width" v-on:click="makeChoice('C9.1');">
                                {{'Do not want to sign'|trans}}
                            </button>
                        </div>


                        <div class="col-xs-12 ">
                            <button class="btn btn-primary full-width" v-on:click="job.workerIntervention.isFailtExplainOpen = true, job.workerIntervention.fails.failId = 50">
                                {{'Other? explain'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12 ">
                            <OtherRaisonExplain
                                    v-bind:label="'Please write minimun 8 characters'|trans"
                                    v-bind:placeholder="'Explain the raison'|trans" v-if="job.workerIntervention.isFailtExplainOpen"
                                    v-on:continue="makeChoice('C9.2')" v-model="job.workerIntervention.fails.failExplanation">
                            </OtherRaisonExplain>
                        </div>


                    </div>

                    <div v-if="job.workerIntervention.step==='F3'" v-bind:key="'F3'" class="block-form col-xs-12">
                        <VoucherExit v-bind:voucher="job.workerIntervention.voucher"
                                     v-bind:job="job"
                                     v-on:save="makeChoice('F3.1')"
                                     v-on:recalculatePrices="reComputePrices"
                                     v-bind:isFormStepBack="isFormStepBack"
                        >
                        </VoucherExit>
                    </div>

                    <div v-if="job.workerIntervention.step==='F8'" v-bind:key="'F8'">
                        <VoucherPreview
                                v-bind:voucher="job.workerIntervention.voucher"
                                v-bind:job="job"
                                v-on:save="makeChoice('F8.1')"
                                v-on:makeChoice="makeChoice"
                                v-on:recalculatePrices="reComputePrices"
                        >
                        </VoucherPreview>
                    </div>

                    <div v-if="job.workerIntervention.step==='F4'" v-bind:key="'F4'" class="block-form col-xs-12">
                        <div class="">

                            <div class="job-number">#{{job.id|TruncateJobNumber}}</div>

                            <strong>
                                <h4 class="text-center">{{'Accounts'|trans}}</h4>
                            </strong>

                            <div class="text-center alert-info alert">
                                <strong>{{'Please enter payments received.'|trans}}</strong>
                            </div>

                            <div class="col-xs-12 items-background" >
                                <label>{{'Items Purchased for this job'|trans}}  </label><br>
                                <div class="col-xs-3 no-padding">
                                    <CurrencyInput v-model="job.workerIntervention.account.pieces" class="form-control"></CurrencyInput>
                                </div>
                            </div>


                            <div class="col-xs-4 ">
                                <label>{{'Price'|trans}}</label>
                                <input type="text" readonly v-bind:value="job.workerIntervention.voucher.total_vat_incl.toFixed(2)" class="form-control">
                            </div>


                            <div class="col-xs-4">
                                <label>{{'Cash'|trans}}</label>
                                <CurrencyInput v-model="job.workerIntervention.account.cash" class="form-control"></CurrencyInput>
                            </div>


                            <div class="col-xs-4">
                                <label>{{'Bancontact'|trans}}</label>
                                <CurrencyInput v-model="job.workerIntervention.account.paidByBc" class="form-control"></CurrencyInput>
                            </div>

                            <div class="col-xs-12">
                                <br>
                                <strong><h5>{{'Total'|trans}} : {{ totalAccount.toFixed(2) }} </h5></strong>
                            </div>
                            <div class="col-xs-12" v-if="job.workerIntervention.voucher.clientWillPay === false">
                                <label class="text-small">
                                    <input type="checkbox" v-model="job.workerIntervention.voucher.clientWillPayCheckbox">
                                    {{'Nothing to declare'|trans }}
                                </label>
                            </div>

                            <div class="col-xs-12">
                                <button :disabled="disabledButtonAccounts" class="btn btn-primary"
                                        v-on:click="makeChoice('F4.1')">{{'Save Accounts'|trans }}
                                </button>
                            </div>

                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C13'" v-bind:key="'C13'">
                        <div class="col-xs-12 text-center">
                            <strong><h4>{{soldeAccount|Round}}{{ $currency.symbol(job.customerAddressIntervention.countryName)}} <br>
                                {{'The client will pay the amount?'|trans}}</h4></strong>
                        </div>
                        <div class="col-xs-6">
                            <button class="btn btn-primary" v-on:click="makeChoice('C13.1')">{{'Yes'|trans}}</button>
                        </div>
                        <div class="col-xs-6">
                            <button class="btn btn-primary" v-on:click="makeChoice('C13.2')">{{'Non'|trans}}</button>
                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C15'"  v-bind:key="'C15'">
                        <div class="col-xs-12 text-center">
                            <h4>{{'Would you like to create an invoice'|trans}}</h4>
                        </div>
                        <div class="col-xs-6">
                            <button class="btn btn-primary" v-on:click="makeChoice('C15.1')">{{'Yes'|trans}}</button>
                        </div>
                        <div class="col-xs-6">
                            <button class="btn btn-primary" v-on:click="makeChoice('C15.2')">{{'Non'|trans}}</button>
                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C16'" v-bind:key="'C16'">
                        <div class="wi-alert alert-danger pull-left" v-if="hasMandatorySkippedSteps()">
                            <strong>{{'You have skipped important steps to create the invoice'|trans}}</strong>
                            <hr class="no-margin">
                            <div class="content-alert-steps">
                                <ul class="no-padding list-group">
                                    <li v-for="(key, item) in requiredSteps" class="alert-step-skipped list-group-item">
                                        <span v-if="item==='F10'">{{'Customer Information'|trans}}   <i class="fa" v-bind:class="key ? 'fa-exclamation-triangle red-text':'fa-check green-text'"></i> </span>
                                        <span v-if="item==='F3'">{{'Voucher'|trans}}                 <i class="fa" v-bind:class="key ? 'fa-exclamation-triangle red-text':'fa-check green-text'"></i> </span>
                                        <span v-if="item==='F4'">{{'Payment received'|trans}}        <i class="fa" v-bind:class="key ? 'fa-exclamation-triangle red-text':'fa-check green-text'"></i></span>
                                    </li>
                                </ul>
                            </div>
                            <button class="btn btn-primary btn-xs" @click="goToStep(getFirstUnvalidStepForInvoice)">{{'Correct those steps'|trans}}</button>
                        </div>

                        <SendInvoiceToCustomer v-bind:job="job" v-if="!hasMandatorySkippedSteps()" v-on:gotoNextStep="makeChoice('C13.1')"></SendInvoiceToCustomer>

                    </div>

                    <div v-if="job.workerIntervention.step==='C10'" v-bind:key="'C10'">
                        <div class="col-xs-6">
                            <PhoneNumberButton></PhoneNumberButton>
                        </div>
                        <div class="col-xs-6">
                            <button class="btn btn-primary" v-on:click="makeChoice('C10.2')">
                                <nl2br tag="span" :text="'The customer will never pay'|trans"/>
                            </button>
                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C6'" v-bind:key="'C6'">

                        <div class="col-xs-12">
                            <div class="alert alert-info text-center">
                                <strong>
                                    {{'Try to get a payment, even if lower than our price. We can help you by phone.'|trans}}
                                </strong>
                            </div>
                        </div>

                        <div class="col-xs-6">
                            <PhoneNumberButton></PhoneNumberButton>
                        </div>
                        <div class="col-xs-6">
                            <button class="btn btn-primary" v-on:click="makeChoice('C6.2')">{{'Refuse to pay'|trans}}
                            </button>
                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C7'" v-bind:key="'C7'">
                        <div class="col-xs-12">
                            <div class="alert alert-info text-center">
                                <strong>{{'Refuse to pay'|trans}}</strong><br>
                                <strong>{{'You can go to next client'|trans}}</strong>
                            </div>
                        </div>
                    </div>

                    <div v-if="job.workerIntervention.step==='C11'" v-bind:key="'C11'" class="">

                        <div class="text-center">
                            <strong><h4>{{'Should create a quotation?'|trans}}</h4></strong>
                        </div>

                        <div class="col-xs-4 little-padding">
                            <button class="btn btn-primary " v-on:click.stop="makeChoice('C11.1');">
                                <nl2br tag="span" :text="'Now'|trans"/>
                            </button>
                        </div>

                        <div class="col-xs-4 little-padding">
                            <button class="btn btn-primary" v-on:click="makeChoice('C11.2');">
                                <nl2br tag="span" :text="'Later'|trans"/>
                            </button>
                        </div>

                        <div class="col-xs-4 little-padding">
                            <button class="btn btn-primary" v-on:click="makeChoice('C11.3');">{{'Non'|trans}}</button>
                        </div>

                    </div>

                    <div v-if="job.workerIntervention.step==='C12'" v-bind:key="'C12'" class="">

                        <div class="text-center">
                            <strong>{{'Please write very briefly what is it to remind you later'|trans}}</strong>
                        </div>

                        <textarea type="text" class="form-control" v-model="job.workerIntervention.quote.private_note"></textarea>
                        <div class="full-width little-padding">
                            <button class="btn btn-primary" v-on:click="makeChoice('C12.1');">{{'Continuer'|trans}}</button>
                        </div>

                    </div>

                    <div v-if="job.workerIntervention.step==='F7'" v-bind:key="'F7'">
                        <div class="col-xs-10">
                            <strong>{{'Please write the email of customer'|trans}}</strong>
                            <input type="input" class="form-control" v-model="job.workerIntervention.customer.email" autocomplete="false">
                        </div>
                        <div class="col-xs-2 no-padding">
                            <strong>&nbsp;</strong>
                            <button class="small-btn-close-input" v-on:click="makeChoice('F7.1');">{{'OK'|trans}}
                            </button>
                        </div>

                    </div>

                    <div v-if="job.workerIntervention.step==='F9'  " v-bind:key="'F9'" class="qLast ">


                        <div class="col-xs-12 btn-group-spaced">
                            <div class="alert alert-success text-center" v-if="job.workerIntervention.isCompleted">
                                <span class="fa fa-thumbs-up fa-3x"></span><br>
                                <strong>{{'Thanks, You can go to the next customer (or use the following options)'|trans}}
                                </strong>
                            </div>
                        </div>

                        <div class="col-xs-12 btn-group-spaced">
                            <button class="btn btn-primary " v-on:click="showOptions">
                                {{ 'Options post-job' | trans }}
                            </button>
                        </div>

                    </div>

                    <!--{# SHOW COMMUNICATION WHEN * = comm #}}-->
                    <div v-if="job.workerIntervention.selectedJobOption === 'options' " v-bind:key="'TODO_2'" class="form-group ">

                        <div class="col-xs-6 btn-group-spaced">
                            <button
                                    v-on:click="job.workerIntervention.selectedJobOption = 'fix_new_appointment'"
                                    class="btn btn-primary">
                                {{ 'RDV' | trans }}
                            </button>
                        </div>

                        <div class="col-xs-6  btn-group-spaced" v-if="isUserBelgianWorker()">
                            <button class="btn btn-primary" v-on:click="job.workerIntervention.selectedJobOption = 'quotation'">
                                <!--<i class="fa fa-file"></i>-->
                                {{ 'Quote' | trans }}
                            </button>
                        </div>



                        <div class="col-xs-6 btn-group-spaced" v-if="confirm_duplication_of_job">
                            <button class="btn btn-secondary btn-confirm" @click="duplicateJob(job.id)" v-bind:disabled="isDuplicatingJob">
                                {{'Please Confirm'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-6 btn-group-spaced" v-if="confirm_duplication_of_job == false">
                            <button class="btn btn-primary" @click="confirm_duplication_of_job=true">
                                {{'Duplicate Job'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-6 btn-group-spaced" v-if="isUserBelgianWorker()">
                            <div class="row">
                            <Modal v-bind:btnOpenModalTitle="'Take Pictures'|trans"
                                   v-bind:btnCloseModalTitle="'Close'|trans">
                                <div slot="body">
                                    <Pictures
                                            v-bind:jobid="job.id"
                                            v-bind:tagPicture="'global'"
                                    >
                                    </Pictures>
                                </div>
                            </Modal>
                            </div>
                        </div>


                        <div class="col-xs-4 btn-group-spaced" v-if="isUserBelgianWorker()">
                            <button class="btn btn-primary " v-on:click="job.workerIntervention.selectedJobSubOption = 'comm'">
                                <nl2br tag="span" :text="'Comm'|trans"/>
                            </button>
                        </div>

                        <div class="col-xs-4 btn-group-spaced" v-if="isUserBelgianWorker()">
                            <button class="btn btn-primary " v-on:click="job.workerIntervention.selectedJobSubOption = 'send_copy'">
                                <nl2br tag="span" :text="'Send Copy'|trans"/>
                            </button>
                        </div>

                        <div class="col-xs-4 btn-group-spaced">
                            <button class="btn btn-primary " v-on:click="job.workerIntervention.selectedJobSubOption = 'note'">
                                {{ 'Note' | trans }}
                            </button>
                        </div>

                        <div class="col-xs-12 btn-group-spaced" v-if="job.pureContact !== true">
                            <button class="btn btn-primary " v-on:click="job.workerIntervention.selectedJobSubOption = 'update_account_pieces'">
                                {{ 'Items Purchased for this job' | trans }}
                                {{job.pureContact}}
                            </button>
                        </div>


                        <div v-if="job.workerIntervention.selectedJobSubOption === 'comm' && job.isPureContact === false" v-bind:key="'suboption'" class="form-group ">
                            <div class="col-xs-12">
                                {{'If the customer wants to pay by paidBy Bc'|trans}}
                            </div>
                            <div class="col-xs-12 communication-string ">
                                <div class="alert alert-info text-center">
                                    <h4 class=""><strong> +++ {{ job.communication }} +++ </strong></h4>
                                </div>
                                <div class="alert alert-success text-center">
                                    {{'Bank Account'|trans}}
                                    <h4>{{ bankAccountInformation }}</h4>
                                </div>
                            </div>
                        </div>



                        <div v-if="job.workerIntervention.selectedJobSubOption === 'update_account_pieces' && !job.isPureContact"

                             v-bind:key="'suboption'"
                             class="form-group "
                        >
                            <div class="text-center">
                                <strong>{{'Please enter payments received.'|trans}}</strong>
                            </div>

                            <div class="col-xs-12 items-background">
                                <label>{{'Items Purchased for this job'|trans}}  </label><br>
                                <div class="col-xs-3 no-padding">
                                    <CurrencyInput v-model="job.account.pieces" class="form-control"></CurrencyInput>
                                </div>
                                <button class="btn btn-primary" @click="saveSparePartsAmount()">{{'Submit'}}</button>

                                <div class="alert alert-success" v-if="isSaveSparePartsSuccess">{{'Saved'}}</div>

                            </div>

                        </div>

                        <div v-if="job.workerIntervention.selectedJobSubOption === 'send_copy'" v-bind:key="'suboption'" class="form-group ">
                            <div class="col-xs-12">
                                <transition name="fademessage">
                                    <div class="alert alert-danger" v-if="sendVoucherError">{{'Something was wrong please try later !'|trans}}</div>
                                </transition>

                                <input type="input" class="form form-control" v-model="job.workerIntervention.customer.email">

                                {{'Do you want to send a voucher copy to your customer by email ?'|trans}}
                                <div class="btn btn-primary full-width" v-on:click="sendVoucherByEmail" v-if="!sendingVoucherByEmail">
                                    {{'Send a copy of voucher By Email'|trans}}
                                </div>

                                <div class="alert alert-success" v-if="sendingVoucherByEmail">
                                    {{'Sending voucher by email please wait ... '|trans}}
                                </div>
                            </div>
                        </div>


                        <div v-if="job.workerIntervention.selectedJobSubOption === 'note'" v-bind:key="'suboption'" class="form-group "

                        >
                            <div class="col-xs-12">{{'A useful remark about this job?'|trans}}</div>
                            <div class="col-xs-9">
                            <textarea type="text"
                                      cols="24" name=""
                                      v-bind:placeholder="'Note' | trans" class="form-control"
                                      v-model="job.workerIntervention.note">

                            </textarea>
                            </div>
                            <div class="col-xs-3">
                                <button class="small-btn-close-input btn-primary" v-on:click="makeChoice('F9.2');">
                                    {{'OK'|trans}}
                                </button>
                            </div>
                        </div>

                    </div>

                    <!--{# CREATE DOCUMENT TYPE DEVIS #}} -->
                    <div v-if="job.workerIntervention.selectedJobOption === 'quotation'" v-bind:key="'TODO_3'" class="">

                        <Quotation
                                v-bind:user="user"
                                v-bind:job="job"
                                v-bind:quote="job.workerIntervention.quote"
                                v-on:quoteDone="makeChoice('F5.1')"
                        ></Quotation>
                    </div>

                    <FixNewAppointment
                            v-if="job.workerIntervention.selectedJobOption === 'fix_new_appointment'"
                            v-bind:job="job"
                            v-on:validateCommentToOfficeForNewAppointment="makeChoice('F9.1')"
                            key="fix_new_appointment">
                    </FixNewAppointment>

                    <div v-if="job.workerIntervention.step === 'F6'" v-bind:key="'F6'" class="form-group ">

                        <div class="col-xs-12">
                            <div class="alert alert-info text-center">
                                <strong>{{'Why the amount is lower than expected'|trans}}</strong>
                            </div>
                        </div>

                        <div class="col-xs-9">
                            <label>{{'Please write minimun 20 characters'|trans}}</label>
                            <input type="text" v-model="job.workerIntervention.explanationWhyAmountLowerThanExpected" class="form-control">
                        </div>

                        <div class="col-xs-3">
                            <button class="small-btn-close-input btn-primary" v-on:click="makeChoice('F6.1');">
                                {{'Submit'|trans}}
                            </button>
                        </div>
                    </div>

                </transition-group>

            </div>

            <div class="col-xs-12 quizz skipBouton" v-if="
            job.workerIntervention.step !== 'C11'
            &&
            job.workerIntervention.step !== 'F9'
            &&
            job.workerIntervention.step !== 'C16'
            &&
            job.workerIntervention.step !== 'C1'
            &&
            job.workerIntervention.step !== 'C2'
            &&
            job.workerIntervention.step !== 'F1'
            &&
            job.workerIntervention.step !== 'quotation'
            &&
            job.workerIntervention.step !== 'F15'
            &&
            job.isPureContact
" id="skipBouton-in-job">
                <SkipBouton v-bind:job="job" v-on:skipStep="skipStep" v-if="editable && isUserBelgianWorker()"></SkipBouton>
            </div>

        </div>
        </transition>
    </div>

</template>

<script>
    import moment from 'moment';
    import PhoneNumberButton from '../PhoneNumberButton';
    import CurrencyInput from '../CurrencyInput';
    import OtherRaisonExplain from './IWasNotThere/OtherRaisonExplain';
    import VoucherExit from '../VoucherExit';
    import VoucherEntry from '../VoucherEntry';
    import VoucherPreview from '../VoucherPreview';
    import JobImpossible from './IWasNotThere/JobImpossible'
    import Modal from '../Modal'
    import ConfirmInline from '../ConfirmInline'
    import CustomerInformation from '../CustomerInformation';
    import Quotation from '../Quotation';
    import Pictures from '../Pictures';
    import FixNewAppointment from '../PostJobOptions/FixNewAppointment';
    import NotAbleToGo from './IWasNotThere/NotAbleToGo';
    import RunningLate from './RunningLate';
    import SendInvoiceToCustomer from '../SendInvoiceToCustomer';
    import SkipBouton from '../SkipBouton';
    import CustomerNotOkOnPhone from "./IWasNotThere/CustomerNotOkOnPhone";
    import TopTagList from './TopTagList';
    import Swap from './Swap';
    import Routing from '../../backend-router';

    import steps from '../../modules/steps';
	import HistoryJob from "./History";
    import BelfixJobMessage from "./BelfixJobMessage";

    export default {
        props: {
            job: null,
            totalJobs: Number,
            editable: null,
            isLoadingJobs:Boolean,
            bankAccountInformation:null,
            _ukey: Number,
            user: Object,
        },
        data() {
            return {
                // How many hours before the appointment the "I'm running late" button
                // appears. MUST match JobController::RUNNING_LATE_OPENS_HOURS_BEFORE.
                runningLateOpensHoursBefore: 3,
            	isHistoryOpen:false,
                isOpenJob : false,
                isJobEditFirstLoading:true,
                is_job_edited:false,
                is_price_policy_open:false,
                callCustomerButton:false,
                conditionLanguageSelected : 'fr',
                conditionLanguage: [
                    {value: 'fr'},
                    {value: 'nl'},
                    {value: 'en'},
                ],
                sendVoucherError :false,
                sendingVoucherByEmail :false,
                isFormStepBack : false,
                confirm_client_do_not_want_sign:false,
                confirm_duplication_of_job : false,
                isDuplicatingJob : false,
                emailVoucher: null,
                customerLanguage : null,
                requiredSteps : {'F10': true,'F3': true,'F4': true},
                stepsToFollow : ["C1","C2","C4","F2","F10","C8","F3","F8","F4","C15","C11","F9"],
                workerIsToEarly : false,
                isSaveSparePartsSuccess:false
            }
        },
        created(){
          if(this.job.disclosed){
            this.isOpenJob = true;
          }
        },
        methods: {
            isUserBelgianWorker(){
                return this.user.country === 'BE';
            },
            openCloseJob(){
                this.isOpenJob = !this.isOpenJob;
                this.$emit('closeAllJobs', this.job);
                this.markAsOpen();
            },
            markAsOpen(){
                if(this.editable === true && this.job.workerIntervention.isJobOpenByWorker === false){
                    this.job.workerIntervention.isJobOpenByWorker = true;
                    this.job.workerIntervention.is_job_edited = true;
                    this.$emit('step_changed');
                }
            },
            //Disable propagation on the current element
            disablePropagation(event){
                event.stopPropagation();
            },
            makeChoice(choice, payload = null) {
                this.job.workerIntervention.extraHeight = null;
                //console.log(choice);
                this.setHistory(choice);
                switch (choice) {
                    case 'F1.1':
                        this.job.workerIntervention.fails.failId = payload.failId;
                        this.job.workerIntervention.createUserTodo = true;
                        this.goToStep('F9');
                        this.formCompleted();
                        break;
                    case 'C1.1':

                        if(!this.isUserBelgianWorker()){
                            this.formCompleted();
                            this.goToStep('F9');
                            this.job.workerIntervention.is_job_edited = true;
                            break;
                        }

                        if(this.job.customer.id === 14731 ){
                            this.job.workerIntervention.fails.failId = 11;
                            this.formCompleted();
                            this.goToStep('F9');
                            this.job.workerIntervention.is_job_edited = true;
                        }else{
                            this.goToStep('C2');
                        }
                        break;
                    case 'C1.2':
                        this.goToStep('F1');
                        break;
                    case 'C2.1':
                        this.job.workerIntervention.buttons.IsClientInPlace = true;
                        this.goToStep('C4');
                        break;
                    case 'C2.2':
                        if ( moment(this.job.dateJobStart.date).isAfter(moment()) ) {
                            this.workerIsToEarly = true; // show for a while
                            setTimeout(()=>{
                                this.workerIsToEarly = false; // hide message
                            }, 10000);
                        }else{
                            this.goToStep('C14');
                        }
                        break;
                    case 'C14.1':
                        this.job.workerIntervention.fails.failId = 12; //Client non présent
                        this.job.workerIntervention.buttons.IsClientInPlace = false;
                        this.job.workerIntervention.createUserTodo = true;
                        this.goToStep('F9');
                        this.formCompleted();
                        break;
                    case 'C4.1':
                        this.job.workerIntervention.fails.failId = null;
                        this.job.workerIntervention.voucher.workTimeStart = new Date();
                        this.goToStep('F2');

                        this.job.workerIntervention.extraHeight = 'extraHeight';
                        break;
                    case 'C4.2':
                        this.goToStep('C5');
                        break;
                    case 'C5.1':
                        this.goToStep('C8');
                        break;
                    case 'C5.2':
                        this.job.workerIntervention.fails.failId = 20; // Client do not want to sign
                        this.goToStep('C8');
                        break;
                    case 'C5.6':
                        this.job.workerIntervention.fails.failId = 21; // Client do not want to pay
                        this.goToStep('F3');
                        break;
                    case 'C5.3': // FAIL
                        this.job.workerIntervention.fails.failId = 6; //Garantie
                        this.goToStep('F9');
                        this.formCompleted();
                        break;
                    case 'C5.4': // FAIL
                        this.job.workerIntervention.fails.failId = 7; // Doublon
                        this.goToStep('F9');
                        this.formCompleted();
                        //this.goToStep('C6');
                        break;
                    case 'C5.5': // FAIL EXPLAIN
                        this.job.workerIntervention.activateInputTextExplainOtherProblem = false;
                        this.job.workerIntervention.createUserTodo = true;
                        this.goToStep('F9');
                        this.formCompleted();
                        break;
                    case 'C5.7': // Used in  modal create a quota
                        this.job.workerIntervention.createQuotation = true; // set this value to true to create a quotation
                        this.job.workerIntervention.createUserTodo = true;
                        this.showFlashMessage();
                        this.goBack();
                        break;
                    case 'C6.1':
                        //this.goToStep('C6'); // SHOW LINK TO CALL CLIENT
                        break;
                    case 'C6.2':
                        this.goToStep('C7'); // FAIL REFUSE PAYER
                        this.formCompleted();
                        break;
                    case 'F2.1':
                        this.goToStep('F10');
                        break;
                    case 'F10.1':
                        this.requiredSteps.F10 = false;
                        this.job.workerIntervention.nextStepAfterThanks ='C5.1';
                        this.goToStep('thanks_customer');
                        break;
                    case 'C8.1':
                        this.job.workerIntervention.voucher.workTotalTimeInMinutes = moment.duration( moment(this.job.workerIntervention.voucher.workTimeEnd).diff(moment(this.job.workerIntervention.voucher.workTimeStart))).asMinutes();
                        this.goToStep('F3');
                        break;
                    case 'C9.1':
                        this.job.workerIntervention.fails.failId = 20;// Client do not want to pay
                        this.goToStep('F4');
                        break;
                    case 'C9.2':
                        this.goToStep('F4');
                        break;
                    case 'F3.1':
                        this.requiredSteps.F3 = false;
                        this.reComputePricesVAT();
                        this.job.workerIntervention.voucher.workTimeEnd = new Date();
                        this.goToStep('F8');
                        break;
                    case 'F8.1':
                        this.job.workerIntervention.nextStepAfterThanks = 'F8.2';
                        this.goToStep('thanks_customer');
                        break;
                    case 'F8.2':
                        this.goToStep('F4');
                        break;
                    case 'C11.1':
                        this.job.workerIntervention.is_job_edited = true;
                        this.formCompleted();
                        this.job.workerIntervention.selectedJobOption = 'quotation';
                        this.isOpenJob = true;
                        //this.goToStep('F9');
                        break;
                    case 'C11.2':
                        this.goToStep('C12');
                        break;
                    case 'C11.3':
                        //AV
                        this.goToStep('F9');
                        this.formCompleted();
                        this.isOpenJob = true;
                        this.job.workerIntervention.is_job_edited = true;
                        //this.$emit('step_changed');
                        break;
                    case 'C11.4':
                        this.goToStep('F7');
                        break;
                    case 'C12.1':
                        this.job.workerIntervention.selectedJobOption = 'quotation';
                        this.job.workerIntervention.rememberCreateQuotation = true;
                        this.goToStep('F9');
                        this.formCompleted();
                        this.isOpenJob = true;
                        break;
                    case 'F7.1':
                        if (!this.hasExpectedAmount()) {
                            this.goToStep('F6');
                        } else {
                            this.formCompleted();
                            this.goToStep('F9');
                        }
                        break;
                    case 'C8.2':
                        this.goToStep('C9');
                        break;
                    case 'C13.1':
                        this.goToStep('C11');
                        break;
                    case 'C13.2':
                            this.goToStep('C10');
                        break;
                    case 'F4.1':
                        this.requiredSteps.F4 = false;
                        if (!this.hasExpectedAmount()) {
                            this.goToStep('C13');
                        } else {
                            if(this.job.isPureContact) {
                                this.goToStep('C15');
                            }else{
                                this.goToStep('C11');
                            }
                        }
                        break;
                    case 'F5.1':
                        this.isOpenJob = false;
                        this.job.workerIntervention.createQuotation = true; // set this value to true to create a quotation
                        this.showFlashMessage();
                        this.goToStep('F9');
                        this.formCompleted();
                        this.$emit('job_form_completed');
                        this.job.workerIntervention.createQuotation = false; // revert value after saving data
                        this.job.workerIntervention.rememberCreateQuotation = false;
                        break;
                    case 'F6.1':
                        this.goToStep('F9');
                        this.formCompleted();
                        break;
                    case 'C10.2':
                        this.goToStep('C11');
                        break;
                    case 'F9.1':
                        this.isOpenJob = false;
                        this.job.workerIntervention.askForNewJobSchedule = true;
                        this.job.workerIntervention.createUserTodo = true;
                        this.formCompleted();
                        this.showFlashMessage();
                        this.$emit('step_changed');
                        this.$emit('get_jobs');
                        this.job.workerIntervention.askForNewJobSchedule = false;
                        break;
                    case 'F9.2':
                        this.isOpenJob = false;
                        this.job.isCompleted = true;
                        this.showFlashMessage();
                        this.formCompleted();
                        this.$emit('step_changed');
                        this.$emit('get_jobs');
                        break;
                    case 'F9.3':
                        this.isOpenJob = false;
                        this.showFlashMessage();
                        this.formCompleted();
                        this.goToStep('F9');
                        break;
                    case 'take_door_picture':
                        this.goToStep('take_door_picture');
                        break;
                    case 'take_sticker_picture':
                        this.goToStep('take_sticker_picture');
                        break;
                    case 'quotation':
                        this.goToStep('quotation');
                        break;
                    case 'C15.1' :
                        this.goToStep('C16');
                        break;
                    case 'C15.2' :
                        this.goToStep('C11');
                        break;
                    default :
                    console.log('DONT FIND : ' + choice);
                }
                console.log(this.job.workerIntervention.step);
            },
            showFlashMessage() {
                this.job.workerIntervention.flashMessage = true;
                // A retenir
                this.job.workerIntervention.selectedJobOption = null;
                setTimeout(() => {
                    this.job.workerIntervention.flashMessage = false;
                }, 4 * 1000);
            },
            showFlasErrorMessage() {
                this.job.workerIntervention.flashErrorMessage = true;
                // A retenir
                this.job.workerIntervention.selectedJobOption = null;
                setTimeout(() => {
                    this.job.workerIntervention.flashErrorMessage = false;
                }, 4 * 1000);
            },
            formCompleted() {
                this.job.workerIntervention.isTrasparentActif = false;
                this.job.workerIntervention.isCompleted = true; // used just to show buttons on the next job
                this.job.isCompleted = true; // used just to show buttons on the next job
            },
            goToStep(step, isStepSkipped = false) {

                this.confirm_client_do_not_want_sign = false;
                this.$scrollTo(this.$refs['jobCard']);
                this.job.workerIntervention.isTrasparentActif = true;
                if(this.job.workerIntervention.step !== "thanks_customer"){ // do not register thanks screen
                    this.job.workerIntervention.previousSteps.push([this.job.workerIntervention.step, isStepSkipped]);
                }
                this.job.workerIntervention.step = step;
                let prevStepsLength = this.job.workerIntervention.previousSteps.length;
                if (prevStepsLength > 0) {
                    this.job.workerIntervention.isQuizzOpen = true;
                }
                this.isFormStepBack = false;
            },
            goBack() {
                // guard clause, should theoretically not happen
                if (this.job.workerIntervention.previousSteps.length === 0) {
                    throw Error(`trying to 'go back' from step [${this.job.workerIntervention.step}] while there is no previous step`);
                }

                const currentStep = this.job.workerIntervention.step;
                let potentialNextStep = this.job.workerIntervention.previousSteps.pop()[0];
                // avoid jumping to a step 'after' the current step
                while (
                    steps.stepIsAfterOrSameAs(potentialNextStep, currentStep, this.$bugsnagClient)
                    && this.job.workerIntervention.previousSteps.length > 0
                ) {
                    potentialNextStep = this.job.workerIntervention.previousSteps.pop()[0];
                }
                this.job.workerIntervention.step = potentialNextStep;

                // do some imperative setup when going back to any step
                this.$scrollTo(this.$refs['jobCard']);
                this.isFormStepBack = true;

                // do some imperative setup when going back to the first step
                if (this.job.workerIntervention.step === 'C1') {
                    this.job.workerIntervention.isTrasparentActif = false;
                    this.job.workerIntervention.isQuizzOpen = false;
                }

            },
            async callCustomer(jobID) {

                this.job.workerIntervention.customerPhoneNumber = 'Working...';
                const response = await this.$api.job.getCustomerPhone(jobID);
                this.job.workerIntervention.customerPhoneNumber = response.show_number;
                this.callCustomerButton = true;

            },
            onQuotationClick() {
                this.isOpenJob = true;
                this.job.workerIntervention.isOpenDevis = true;
                this.job.workerIntervention.selectedJobOption = 'quotation';
                this.goToStep('F9');
            },
            onPolicyCLick(){
                this.is_price_policy_open = !this.is_price_policy_open;
            },
            hasExpectedAmount() {

                if(this.job.workerIntervention.voucher.clientWillPayCheckbox){
                    return true;
                }

                let total_vat_incl = (Math.round(this.job.workerIntervention.voucher.total_vat_incl * 100) / 100);
                let total_bancontact_cash = (Math.round((this.job.workerIntervention.account.cash + this.job.workerIntervention.account.paidByBc) * 100) / 100);
                if (total_bancontact_cash < total_vat_incl) {
                    return false;
                }
                return true;
            },
            setHistory(content) {
                this.job.workerIntervention.historySteps = this.job.workerIntervention.historySteps + " " + content + "\n";
            },
            showOptions(){
                this.navigatorOnline = navigator.onLine;
                if(this.navigatorOnline){
                    this.job.workerIntervention.selectedJobOption = (this.job.workerIntervention.selectedJobOption === 'options' ?  null : 'options');
                }else{
                    alert('Internet is not connected');
                }
            },
            reComputePrices() {

                let sumOfPrices = this.job.workerIntervention.voucher.items.reduce(
                    function (accumulator, item) {
                        return accumulator + item.price;
                    },
                    0
                );

                let vatc = false;
                if(this.job.workerIntervention.voucher.vat_regime == "-21" || this.job.workerIntervention.voucher.vat_regime == "-6" ){
                    vatc = true;
                }

                if(this.job.workerIntervention.voucher.quarterOfHour.enabledWorkForce && this.job.workerIntervention.voucher.pricePolicyHourCalculation === 'byQuarterOfHour'){
                    sumOfPrices = (sumOfPrices +this.job.workerIntervention.voucher.quarterOfHour.price);
                }

                if(this.job.workerIntervention.voucher.byHour.enabledWorkForce && this.job.workerIntervention.voucher.pricePolicyHourCalculation === 'byHour'){
                    sumOfPrices = (sumOfPrices +this.job.workerIntervention.voucher.byHour.price);
                }

                if(vatc){
                    let vat = Math.abs(this.job.workerIntervention.voucher.vat_regime);
                    this.job.workerIntervention.voucher.vat_to_pay     = sumOfPrices / (1 + (vat /100)) * (vat/ 100);
                    this.job.workerIntervention.voucher.total = sumOfPrices - this.job.workerIntervention.voucher.vat_to_pay;
                    this.job.workerIntervention.voucher.total_vat_incl = sumOfPrices;
                }else{
                    this.job.workerIntervention.voucher.total_vat_incl = sumOfPrices * (1 +this.job.workerIntervention.voucher.vat_regime / 100);
                    this.job.workerIntervention.voucher.total = sumOfPrices;
                    this.job.workerIntervention.voucher.vat_to_pay     = sumOfPrices * (this.job.workerIntervention.voucher.vat_regime/ 100);
                }
                this.job.workerIntervention.account.cash = this.job.workerIntervention.voucher.total_vat_incl;
            },
            reComputePricesVAT(){
                /**
                 * Only if negatif number can change those values
                 */
                if(this.job.workerIntervention.voucher.vat_regime<0){
                    this.job.workerIntervention.voucher.vat_regime = Math.abs(this.job.workerIntervention.voucher.vat_regime);
                    let vat = this.job.workerIntervention.voucher.vat_regime;

                    this.job.workerIntervention.voucher.items = this.job.workerIntervention.voucher.items.map(
                        function (item) {
                            item.price = item.price / (1 + (vat/100));
                            return item;
                        }
                    );

                    let sumOfPrices = this.job.workerIntervention.voucher.items.reduce(
                        function (accumulator, item) {
                            return accumulator + item.price;
                        },
                        0
                    );

                    if(this.job.workerIntervention.voucher.quarterOfHour.enabledWorkForce && this.job.workerIntervention.voucher.pricePolicyHourCalculation === 'byQuarterOfHour'){
                        this.job.workerIntervention.voucher.quarterOfHour.price  =  this.job.workerIntervention.voucher.quarterOfHour.price / (1 + (vat/100));
                        sumOfPrices = (sumOfPrices +this.job.workerIntervention.voucher.quarterOfHour.price);
                    }

                    if(this.job.workerIntervention.voucher.byHour.enabledWorkForce && this.job.workerIntervention.voucher.pricePolicyHourCalculation === 'byHour'){
                        this.job.workerIntervention.voucher.byHour.price =  this.job.workerIntervention.voucher.byHour.price / (1 + (vat/100));
                        sumOfPrices = (sumOfPrices +this.job.workerIntervention.voucher.byHour.price);
                    }

                    this.job.workerIntervention.voucher.vat_to_pay     = sumOfPrices * (this.job.workerIntervention.voucher.vat_regime/ 100);
                    this.job.workerIntervention.voucher.total_vat_incl = sumOfPrices * (1 +this.job.workerIntervention.voucher.vat_regime / 100);
                    this.job.workerIntervention.voucher.total = sumOfPrices;

                    this.job.workerIntervention.account.cash = this.job.workerIntervention.voucher.total_vat_incl;
                    this.job.workerIntervention.voucher.vat_to_pay = Math.abs(sumOfPrices * (this.job.workerIntervention.voucher.vat_regime/ 100));

                }

            },
            async sendVoucherByEmail(){

                this.sendingVoucherByEmail = true;
                try{
                    const response = await this.$api.voucher.sendVoucherByEmail(this.job.id, this.job.workerIntervention.customer.email);
                    if(response.is_email_sent){
                        this.showFlashMessage();
                    }else{
                        this.showFlasErrorMessage();
                    }

                }catch(error){
                    this.sendVoucherError = true;
                }

                setTimeout(() => this.sendVoucherError = false, 2500);

                this.sendingVoucherByEmail = false;
            },
            validateEmail(email) {
                if(email){
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                }else{
                    return true;
                }
            },
            async duplicateJob(jobID){
                this.isDuplicatingJob = true;
                const response = await this.$api.worker.duplicateJob(jobID);
                if(response.success === true && response.is_job_cloned === true){
                    this.$emit('get_jobs');
                    this.confirm_duplication_of_job = false;
                    this.isDuplicatingJob = false;
                }else{
                  alert('This job has already been cloned');
                }
            },
            hideIfValueLessOrEqualToZero(value){
                if( value <= 0 ){
                    return false
                }
                return true;
            },
            emitGetJobsAfterDelay(job) {

                job.workerIntervention.isCompleted=true;
                this.$emit('step_changed');

                setTimeout(
                    () => {
                        this.$emit('get_jobs');
                    },
                    1000
                );
            },
            discloseAndShowBoutons(discloseBouton, responseConfirmation){
                this.job.workerIntervention.pureContact.dateTimeOfDisclosure = new Date();
                this.job.workerIntervention.pureContact.disclosedTroughtBouton = discloseBouton;
                if( responseConfirmation === true ){
                    this.job.workerIntervention.pureContact.discloseAccepted = true;
                    this.job.disclosed = true;
                    this.job.workerIntervention.is_job_edited=true;
                    this.$emit('step_changed');
                }
                if( responseConfirmation === undefined ){
                    return true;
                }
            },
            getHouseNumber(){

            	if(this.job.isWorkerTheOwner === true){
					return this.job.customerAddressIntervention.number;
                }

                if(
                    (this.isJobNewAndPureContactAndNotNovice === true && this.job.workerIntervention.pureContact.discloseAccepted)
                    ||
                    (this.isJobNewAndPureContactAndNotNovice === false && this.editable)
                ){
                    return this.job.customerAddressIntervention.number;
                }
                const houseNumber = parseInt(this.job.customerAddressIntervention.number);
                return Math.max(1, houseNumber + Math.round((Math.random()*30) - 15));
            },
            skipStep(){

                const self = this;
                const currentStep = this.job.workerIntervention.step;
                let nextStep = this.stepsToFollow.findIndex((step) => {return step === currentStep}) + 1;

                //console.log(this.stepsToFollow[nextStep]);
                if(this.stepsToFollow[nextStep] === "F10"){
                    this.requiredSteps.F10 = true;
                }
                if(this.stepsToFollow[nextStep] === "F3"){
                    this.requiredSteps.F3 = true;
                }
                if(this.stepsToFollow[nextStep] === "F4"){
                    this.requiredSteps.F4 = true;
                }

                if(nextStep < 6 && currentStep !== "C8" ) {
                    this.goToStep('C8', true);
                    return false;
                }

                if(nextStep >= 6 && currentStep !== "C15"){
                    this.goToStep('C15', true);
                    return false;
                }

                if(this.stepsToFollow[nextStep]==="F2"){
                    this.job.workerIntervention.voucher.workTimeStart = new Date();
                }
                if(this.stepsToFollow[nextStep]==="F8") {
                    this.job.workerIntervention.voucher.workTimeEnd = new Date();
                }


                if(nextStep!==0){
                    this.goToStep(this.stepsToFollow[nextStep], true);
                }else{
                    this.goBack()
                }
            },
            getRequiredStepsForInvoice(){
                let requiredSteps = this.requiredSteps;
                requiredSteps.forEach((valuePrevious,indexPrevious)=>{
                    let exists = false;
                    this.job.workerIntervention.previousSteps.forEach((value,index)=>{
                        if(Object.keys(valuePrevious)[0] === value[0] && value[1]===true){
                            exists = true;
                        }
                    });
                    requiredSteps[indexPrevious][Object.keys(valuePrevious)[0]] = exists;
                });
                return requiredSteps;
            },
            hasMandatorySkippedSteps(){
                if( this.requiredSteps.F10 === true ||
                    this.requiredSteps.F3 === true ||
                    this.requiredSteps.F4 === true){
                    return true;
                }
                return false;

            },
            opacityJobsQttIncrease(){
                const opacity = Math.max(0, 1 - ( 0.05 * this.totalJobs ) );
                return { opacity: opacity + ' !important'}
            },
            async saveSparePartsAmount(){
                //Strictly Save Parts
                this.isSaveSparePartsSuccess = true;
                await this.$api.job.saveSparePartsAmount(this.job.id, this.job.account.pieces);
            },
            getInvoicePath(documentId){
                return  process.env.VUE_APP_API_BASE_URL + Routing.generate('worker_interface_generate_pdf', {id: documentId, action : 'generate','with_voucher':false});
            },
        },
        watch: {
            'job.workerIntervention': {
                handler: function (after,before) {
                    if(this.isJobEditFirstLoading === false){ // avoid the first set is job edited when ajax are called
                        this.job.workerIntervention.is_job_edited = true;
                    }
                    this.isJobEditFirstLoading = false;

                },
                deep: true,
            },
            'job.workerIntervention.step': {
                handler: function () {
                    this.$emit('step_changed', this.job.workerIntervention.isCompleted);
                }
            },
            'job.workerIntervention.account.total'(){
                if(this.job.workerIntervention.account.total !== 0){
                    this.job.workerIntervention.voucher.clientWillPayCheckbox = false;
                    this.job.workerIntervention.voucher.clientWillPay = true;
                }else{
                    this.job.workerIntervention.voucher.clientWillPay = false;
                }
            }
        },
        computed: {
            // A delay can only be announced while the job is still going to happen:
            // it must have a confirmed appointment time, and that time must not be
            // long past (after that it is a no-show, not a delay).
            //
            // ANTI-ABUSE: it must ALSO be too late for the worker to be refunded.
            // While a refund is still possible, announcing a fake delay is a way to
            // push the customer into cancelling and walk away with the money back.
            // The server enforces the same rule and returns 403 'still_refundable',
            // this only keeps the button out of sight.
            canDeclareRunningLate() {
                if (!this.job || !this.job.dateJobStart) {
                    return false;
                }
                const start = moment(this.job.dateJobStart.date);
                if (!moment().isBefore(start.clone().add(2, 'hours'))) {
                    return false;
                }
                return !this.isStillRefundable;
            },

            // True while the worker still has enough at stake for a fake delay to pay off.
            //
            // The refund ladder (WorkerPureContactTransactionService::getRefundRatioForPartialRefund)
            // is 100% up to 3 days before, 60% up to 24 hours, 30% up to 3 hours, then 10%
            // until 1 minute before. We open the button at the 3-hour mark, where the stake
            // drops to 10%, about 9.50 EUR on an average 95 EUR purchase.
            //
            // MUST match JobController::RUNNING_LATE_OPENS_HOURS_BEFORE. If you change one,
            // change the other, or the button appears and the server answers 403.
            isStillRefundable() {
                if (!this.job || !this.job.dateJobStart) {
                    return true;
                }
                if (this.job.isPureContact !== true || this.job.isWorkerTheOwner === true) {
                    return false;
                }
                if (this.job.disclosed === true) {
                    return false;
                }
                const cutoff = moment(this.job.dateJobStart.date)
                    .subtract(this.runningLateOpensHoursBefore, 'hours');
                return moment().isBefore(cutoff);
            },
            getFirstUnvalidStepForInvoice(){
                let stepNotValid = 'F10';
                Object.entries(this.requiredSteps).reverse().forEach((value)=>{
                    if(value[1]){
                        stepNotValid = value[0];
                        return;
                    }
                });
                return stepNotValid;
            },
            hideBackBouton(){

                if(!this.isUserBelgianWorker()){
                    return false;
                }

                if( this.job.isPureContact && this.job.workerIntervention.pureContact.isInvoiceSent){
                    return false;
                }else{
                    return this.job.workerIntervention.step!=='C1'  && this.job.workerIntervention.isCompleted === false
                }
            },
            totalAccount() {
                this.job.workerIntervention.account.total = this.job.workerIntervention.account.price + this.job.workerIntervention.account.paidByBc + this.job.workerIntervention.account.cash
                return this.job.workerIntervention.account.total;
            },
            soldeAccount(){
                return (this.job.workerIntervention.voucher.total_vat_incl - this.job.workerIntervention.account.price - this.job.workerIntervention.account.paidByBc - this.job.workerIntervention.account.cash)
            },
            disabledButtonAccounts(){

                if(this.job.workerIntervention.voucher.clientWillPayCheckbox === true){
                    return false;
                }
                if(this.totalAccount === 0){
                    return true;
                }
                return false;
            },
            // Pure contact Computed
            isJobNewAndPureContactAndNotNovice(){
                return ((this.job.interventionType === 'new' || this.job.interventionType === null ) && this.job.isPureContact === true && this.user.workerIsNovice !== true)
            },
            isJobNew(){
                return (this.job.interventionType === 'new' || this.job.interventionType === null )
            },
            isJobNewAndPureContact(){
                return ((this.job.interventionType === 'new' || this.job.interventionType === null ) && this.job.isPureContact === true)
            },
            isJobNotNewAndPureContact(){
                return (
                    this.job.interventionType === 'continuation' || this.job.interventionType === 'warranty'
                    && this.job.isPureContact === true
                )
            }
        },
        filters: {
            Upper(value) {
                if(value !== null){
                    return value.toUpperCase();
                }else{
                    return value;
                }
            },
            Truncate(value, length) {
                if(value !== null){
                    return value.substring(0, length) + "..";
                }
                return "";
            },
            TruncateJobNumber(value) {
                return value.toString().substr(2, value.toString().length);
            },
            Round(value) {
                if(value !== null){
                    return Math.round(value * 100) / 100;
                }
            },
            br(str) {
                return str.replace(/\n/g, "<br />");
            },
            CreateLink(string) {
                var link = "<a href='#conditions_fr'>Condition générales en Francais</a>";
                return string.replace('%onlick_append_conditions_FR%', link);
            }

        },
        components: {
          BelfixJobMessage,
			HistoryJob,
            CustomerNotOkOnPhone,
            NotAbleToGo,
            RunningLate,
            SendInvoiceToCustomer,
            Pictures,
            Quotation,
            CustomerInformation,
            PhoneNumberButton,
            CurrencyInput,
            OtherRaisonExplain,
            VoucherExit,
            VoucherEntry,
            VoucherPreview,
            JobImpossible,
            Modal,
            ConfirmInline,
            FixNewAppointment,
            SkipBouton,
            TopTagList,
            Swap,
        }
    }
</script>

<style scoped>
    .policyContent{
        background-color: #f7fffa;
        z-index:222223;
        padding:18px 8px;
        color:black;
        position:fixed;
        left:0px;
        top:0px;
        height:100%;
        width: 100%;
    }
    .tags-info .tag{
        font-size:12px;
        border-radius:0px;
    }

    .price-policy-btn{
        background-color: #ff4b18 !important;
    }

    .little-padding  {
        padding: 4px !important;
    }

    .call-btns .btn-call{
        border-radius: 4px;
        border:1px solid #dddddd !important;
        background-color:white !important;
    }

    .address{
        text-transform: lowercase;

    }

    .job-id{
        padding:4px !important;
        text-align:right;
    }

    /* the running-late button, sitting on the collapsed card under the header */
    .running-late-holder{
        padding: 0 10px 10px;
    }

    .padding-startquizz-buttons{
        padding-right:10px !important;;
        padding-left:10px !important;
    }

    #job-worker-list .quizz.startQuizz{
        margin-bottom:10px !important;
        padding:20px;
    }

    .items-background{
        background: #f5f5f5;
        border-radius: 5px;
        padding: 10px;
        margin-bottom:25px;
    }

    .btn-group-spaced{
        padding:3px !important;
        margin:0px !important;
    }
    .scrollable{
        height:310px;
        overflow: hidden;
        overflow-y: scroll
    }
    .job_completed{
        background-color: #cbcbcb !important;
    }
    .job_completed_card{
        border-color: #cbcbcb !important;
    }

    .txt-red{
        color:red;
    }

    .job-number{
        background-color: #3f85d6;
        position:absolute;
        right:0px;
        top:0px;
        margin:10px;
        padding:4px;
        color:white;
    }
    .btn-confirm{
        color:white;
        background-color:red;
    }
    .btn-confirm:hover{
        color:white !important;
        background-color: #d90000;
    }

    .thanks_customer {
        background-color: #00ccbc !important;
        border:10px solid #1cada1!important;
        position: fixed !important;
        top: 0px;
        margin-top:0px !important;
        left: 0px;
        height: 100%;
        overflow-y: scroll;
        padding-bottom: 60px !important;
        z-index: 333333 !important;
        border-radius: 0px;
    }

    .thanks_customer .thanks-message-customer{
        margin-top:55%;
        color:white;
    }

    .thanks_customer .invisible-btn{
        opacity: 0;
    }

    .thanks_customer .back-btn{
        min-height:150px !important;
        top:0px;
        left:0px;
        position:fixed;
    }

    .thanks_customer .go_next_invisible
    {
        position:fixed;
        bottom:0px;
        left:0px;
        min-height:150px !important;
        opacity: 1 !important;
        width: 94% !important;
        margin: 3%;
        border-radius: 18px !important;
        background-color: #00ccbc;
        color: white;
        font-size: 18px;
        font-weight: bold;
        border: 4px dashed;
    }

    .skipBouton{
        border-radius: 0px !important;
        background: white !important;;
        box-shadow: none !important;;
        border: 0px !important;;
    }
    .wi-alert{
        padding:20px;
        border:1px solid gray;
        width: 100%;
    }

    .wi-alert.alert-danger{
        background-color:#f74b17;
        color: white;
    }

    .content-alert-steps{
        background: white;
        color: black;
        padding: 13px;
    }

    .tag-purecontact{
        background-color:orangered;
    }

    .waze-btn{
        border: 1px solid #dadada;
        padding: 5px;
        border-radius: 4px;
        margin-right: 8px;
        background: #f3f3f3;
    }

    .list-simple{
      padding:0;
      margin:0 0 0 10px ;
    }
    .description-price-job{
      color:gray;
    }
    .price-description ul{
      padding:0;
      margin: 0;
    }
    .content-description .row > [class*=col-]{
      margin-bottom: 10px !important;
    }
    .content-description .job-description{
      padding:0 !important;
    }
    .panel-body{
      padding:10px !important;
    }
    .alert-prix-job-description{
      padding:5px 10px !important;
      margin-bottom: 10px;

    }
    .content-description .panel{
      margin-bottom:10px;
    }
</style>

